export const locale = {
    lang: 'en',
    data: {
        NAV: {
            SERVICE_ORDERS: 'Service Orders',
            MENU: 'Menu',
            ALERTING: 'Alerting',
            ALERT: {
                TITLE: 'Alert'
            },
            BACKUPS: {TITLE: 'Backups'},
            RESTORES: {TITLE: 'Restores'},
            SUPER_CONFIG: {TITLE: 'Super Config'},
            APPLICATIONS: 'Setup',
            EMPLOYEE_MANAGEMENT: 'Employee Management',
            ORDER_MANAGEMENT: 'Order Management',
            INVENTORY_MANAGEMENT: 'Inventory Management',
            REPORTING: 'Reports',
            IMPEX: 'Import Data',
            COMPANY_MANAGEMENT: 'Company Management',
            ROUTE_MANAGEMENT: 'Route Management',
            CUSTOMER_MANAGEMENT: 'Customer Management',
            PRODUCT_MANAGEMENT: 'Product Management',
            TASK_MANAGEMENT: 'Task Management',
            FILE_MANAGEMENT: 'File Management',
            DATA_ANALYTICS: 'Analytics',
            SURVEY_MANAGEMENT: 'Survey Management',
            CATALOGUE_MANAGEMENT: 'Catalogue Management',
            DATABASE_MANAGEMENT: 'Database Management',
            DB_USER: 'DB Users',
            AUDIT_LOG: {
                TITLE: 'Audit Log'
            },
            SUPER_ANALYTICS: {
                TITLE: 'Super Analytics'
            },
            AUDIT: 'Audit Management',
            EQUIPMENTS: {
                TITLE: 'Equipments'
            },
            ADMIN_REINDEX: {
                TITLE: 'Admin Reindex'
            },
            DRIVER_APP_ACCESS: {
                TITLE: 'Driver App Access'
            },
            PICKER_APP_ACCESS: {
                TITLE: 'Picker App Access'
            },
            PICKER_PICK_ACCESS: {
                TITLE: 'Pick'
            },
            PICKER_GROUP_PICK_ACCESS: {
                TITLE: 'Group Pick'
            },
            PICKER_LOAD_ORDERS_ACCESS: {
                TITLE: 'Load Orders'
            },
            PICKER_RECEIVE_INVENTORY_ACCESS: {
                TITLE: 'Receive / Adjust Inventory'
            },
            PICKER_PURCHASE_ORDERS_ACCESS: {
                TITLE: 'Purchase Orders'
            },
            PICKER_WAREHOUSE_TRANSFERS_ACCESS: {
                TITLE: 'Warehouse Transfers'
            },
            PICKER_STOCK_TAKE_ACCESS: {
                TITLE: 'Stock Take'
            },
            POS_APP_ACCESS: {
                TITLE: 'POS App Access'
            },
            CLIENT_PORTAL_ACCESS: {
                TITLE: 'Client Portal Access'
            },
            AI_FEATURE: {
                TITLE: 'Get AI Feature'
            },
            USERS: {
                TITLE: 'Users'
            },
            EMAIL_WORKFLOW: {
                TITLE: 'Email Workflow'
            },
            ASYNC_REQUESTS: {
                TITLE: 'Async Requests'
            },
            DELETE_WORKFLOW: {
                TITLE: 'Delete Workflow'
            },
            UPDATE_WORKFLOW: {
                TITLE: 'Update Workflow'
            },
            SERVICE_ITEMS: {
                TITLE: 'Service items'
            },
            WORKFLOW: {
                TITLE: 'Workflow'
            },
            VEHICLE_INSPECTIONS: {
                TITLE: 'Inspections'
            },
            TENANT_MANAGEMENT: {
                TITLE: 'Tenant Management'
            },
            TENANTS: {
                TITLE: 'Tenants'
            },
            ONBOARDING: {
                TITLE: 'Onboarding'
            },
            PROFILES: {
                TITLE: 'Profiles'
            },
            DAILY_ACTIVITY_SUMMARYS: {
                TITLE: 'Daily Activity Summaries'
            },
            CREDIT_NOTE: {
                TITLE: 'Credit Notes'
            },
            USER_CONFIGURATION: {
                TITLE: 'Tenant Configuration'
            },
            PAYMENTS: {
                TITLE: 'Payments'
            },
            SITE_VISITS: {
                TITLE: 'Site Visits'
            },
            CASH_DEPOSITS: {
                TITLE: 'Cash Ledger'
            },
            DRIVER_DEPOSITS: {
                TITLE: 'Cash Deposits'
            },
            ROLES: {
                TITLE: 'Roles'
            },
            SAMPLE: {
                TITLE: 'Branch',
                BADGE: '25'
            },
            /*ACCOUNTING: {
                TITLE: 'Accounting'
            },*/
            WAREHOUSE: {
                TITLE: 'Warehouse'
            },
            MAJOR_ACCOUNT_CODE: {
                TITLE: 'Major Account Codes'
            },
            SUPPLIERS: {
                TITLE: 'Suppliers'
            },
            SERVICE_PRIORITY_CODE: {
                TITLE: 'Service Priority Codes'
            },
            DEPOSIT_ITEM: {
                TITLE: 'Deposit Items'
            },
            PRODUCT_IMEI_TRACK: {
                TITLE: 'IMEI Tracking'
            },
            STATEMENT_CODE: {
                TITLE: 'Statement Codes'
            },
            DUNNING_MESSAGE_CODE: {
                TITLE: 'Dunning Message Codes'
            },
            CREDIT_CLASS: {
                TITLE: 'Credit Class'
            },
            CREDIT_TERM: {
                TITLE: 'Credit Terms'
            },
            DELIVERY_POINT: {
                TITLE: 'Delivery Points'
            },
            STOP_TYPE: {
                TITLE: 'Stop Types'
            },
            VEHICLE_SKILL: {
                TITLE: 'Vehicle Skills'
            },
            PAYMENT_TYPE: {
                TITLE: 'Payment Types'
            },
            CUSTOMER: {
                TITLE: 'Customers'
            },
            CUSTOMER_GROUP: {
                TITLE: 'Customer Groups'
            },
            PROMOTIONS: {
                TITLE: 'Promotions'
            },
            PRICE_LIST: {
                TITLE: 'Price Lists'
            },
            PRODUCT_CLASS: {
                TITLE: 'Product Class'
            },
            PRODUCT_ATTRIBUTE_TYPE: {
                TITLE: 'Product Attribute Types'
            },
            PRODUCT_ATTRIBUTE_WHITELIST: {
                TITLE: 'Attribute Whitelists'
            },
            BRAND: {
                TITLE: 'Brands'
            },
            PRODUCT_LIST: {
                TITLE: 'Product Lists'
            },
            PRODUCT_GROUP: {
                TITLE: 'Product Group'
            },
            UNIT_OF_MEASURE: {
                TITLE: 'Unit of Measure'
            },
            PACKAGING: {
                TITLE: 'Packaging'
            },
            PRODUCT_TAX_CATEGORY: {
                TITLE: 'Product Tax Categories'
            },
            PRODUCT: {
                TITLE: 'Products'
            },
            DELIVERY_PACKAGE_TYPE: {
                TITLE: 'Delivery Package Types'
            },
            VEHICLE: {
                TITLE: 'Vehicles'
            },
            VEHICLE_TYPE: {
                TITLE: 'Vehicle Types'
            },
            TRAILER: {
                TITLE: 'Trailers'
            },
            TRAILER_TYPE: {
                TITLE: 'Trailer Types'
            },
            CORE_REPORTS: {
                TITLE: 'Core Reports'
            },
            TEMPERATURE_REPORTS: {
                TITLE: 'Temperature Reports'
            },
            ROUTE_TYPE: {
                TITLE: 'Route Types'
            },
            ROUTE: {
                TITLE: 'Routes'
            },
            ORDER: {
                TITLE: 'Orders'
            },
            SALE_ORDER: {
                TITLE: 'Sale Orders'
            },
            ORDER_REJECTION_CODE: {
                TITLE: 'Order Rejection Codes'
            },
            INCOMING_INVENTORY: {
                TITLE: 'Receive / Adjust Inventory'
            },
            LOAD_ORDER: {
                TITLE: 'Load Orders'
            },
            REPORTS: {
                TITLE: 'Reports'
            },
            PICK_ORDER: {
                TITLE: 'Pick Orders'
            },
            PACK_ORDER: {
                TITLE: 'Pack Orders'
            },
            DELIVERY_ORDER: {
                TITLE: 'Delivery Orders'
            },
            CUSTOMER_SMS_TEXT: {
                TITLE: 'Customer SMS Texts'
            },
            TERRITORIES: {
                TITLE: 'Territories'
            },
            EMPLOYEE: {
                TITLE: 'Employees'
            },
            EMPLOYEE_GROUP: {
                TITLE: 'Employee Groups'
            },
            HANDHELD_PROFILE: {
                TITLE: 'Handheld Profiles'
            },
            EMPLOYEE_EXPENSES: {
                TITLE: 'Employee Expenses'
            },
            EXPENSE_TYPES: {
                TITLE: 'Expense Types'
            },
            EXPENSE_PAYMENT_METHODS: {
                TITLE: 'Expense Payment Methods'
            },
            IMPORT_DATA: {
                TITLE: 'Import Data'
            },
            ROUTE_DISPATCH: {
                TITLE: 'Route Scheduler'
            },
            ROUTE_PLANNER: {
                TITLE: 'Route Planner'
            },
            ROUTE_COMMAND: {
                TITLE: 'Route Monitor'
            },
            ROUTE_HISTORY: {
                TITLE: 'Route History'
            },
            ROUTE_SCHEDULES: {
                TITLE: 'Route Schedules'
            },
            INVENTORY_STOCK: {
                TITLE: 'Inventory Stock'
            },
            VEHICLE_UNLOADS: {
                TITLE: 'Vehicle Unloads'
            },
            COMPANY: {
                TITLE: 'Company'
            },
            REPORT: {
                TITLE: 'All Reports'
            },
            INVOICE: {
                TITLE: 'Invoices'
            },
            HAULIER_ORDER: {
                TITLE: 'Haulier Orders'
            },
            ORGANISATION: {
                TITLE: 'Organisations'
            },
            STOCK_TAKES: {
                TITLE: 'Stock Takes'
            },
            WAREHOUSE_TRANSFER: {
                TITLE: 'Warehouse Transfer'
            },
            PURCHASE_ORDERS: {
                TITLE: 'Purchase Orders'
            },
            PURCHASE_INVOICE: {
                TITLE: 'Purchase Invoice'
            },
            VEHICLE_CHECK_LIST: {
                TITLE: 'Safety Profiles'
            },
            INVENTORY_TRANSACTIONS: {
                TITLE: 'Inventory Ledger'
            },
            RECIPES: {
                TITLE: 'Recipes'
            },
            PRODUCTION_VOUCHERS: {
                TITLE: 'Production Vouchers'
            },
            CUSTOMER_TRANSACTIONS: {
                TITLE: 'Customer Balance Ledger'
            },
            DRIVER_ACCESS_CODES: {
                TITLE: 'Access Codes'
            },
            CUSTOMER_AGING_REPORTS: {
                TITLE: 'Customer Aging Reports'
            },
            CASH_JOURNAL_REPORTS: {
                TITLE: 'Cash Journal Reports'
            },
            SHORTFALL_REPORT: {
                TITLE: 'Shortfall Reports'
            },
            APP_REQUEST: {
                TITLE: 'App Requests'
            },
            SURVEY: {
                TITLE: 'Surveys'
            },
            EMPLOYEE_TARGET: {
                TITLE: 'Employee Targets'
            },
            ROUTE_TARGET: {
                TITLE: 'Route Targets'
            },
            REASON_CODE: {
                TITLE: 'Reason Codes'
            },
            PRODUCT_COST_CHANGE: {
                TITLE: 'Product Cost Changes'
            },
            STOCK_CHANGE_CONDITION: {
                TITLE: 'Stock Condition Change'
            },
            DEMAND_REPORT: {
                TITLE: 'Demand Report'
            },
            ANALYTICS_DASHBOARD: {
                TITLE: 'Analytics Dashboard'
            },
            EOD_SURVEY: {
                TITLE: 'EOD Survey'
            },
            MAIL_AUDIT: {
                TITLE: 'Mail Audits'
            },
            ACCOUNTING_SYNC_RUNS: {
                TITLE: 'Accounting Sync Runs'
            },
            WORKSHOP: {
                TITLE: 'Workshop'
            },
            SITE_VISIT_SKIP_REASONS: {
                TITLE: 'Site Visit Skip Reasons'
            },
            CUSTOM_FIELD_GROUPS: {
                TITLE: 'Custom Field Groups'
            },
            CUSTOM_FIELDS: {
                TITLE: 'Custom Fields'
            },
            CUSTOM_PDF_TEMPLATES: {
                TITLE: 'Custom PDF Templates'
            },
            ACCOUNTS_PACKAGE_SETUP: {
                TITLE: 'Accounts Package Setup'
            },
            RECIPE_EXECUTION_REPORT: {
                TITLE: 'Recipe Execution Report'
            },
            SUPER_ADMIN: {
                TITLE: 'SUPER ADMIN'
            },
            STANDING_ORDERS: {
                TITLE: 'Standing Orders'
            },
            STANDING_SALE_ORDERS: {
                TITLE: 'Standing Sale Orders'
            },
            STANDING_LOAD_ORDERS: {
                TITLE: 'Standing Load Orders'
            },
            EOD_INVENTORY_REPORT: {
                TITLE: 'EOD Inventory Report'
            },
            SURVEY_REPORT: {
                TITLE: 'Survey Report'
            },
            APP_MANAGEMENT: {
                TITLE: 'App Management'
            },
            APP_VERSION: {
                TITLE: 'App Versions'
            },
            DEFAULT_PRODUCT_PRICE_CHANGE: {
                TITLE: 'Default Price Change'
            },
            BRANCH_PAYMENTS: {
                TITLE: 'Branch Deposits'
            },
            BRANCH_TRANSACTIONS: {
                TITLE: 'Branch Ledger'
            },
            PURCHASE_PAYMENTS: {
                TITLE: 'Purchase Payments'
            },
            PURCHASE_CREDIT_NOTE: {
                TITLE: 'Purchase Debit Notes'
            },
            CATALOGUE: {
                TITLE: 'Catalogue'
            },
            PRESENTATION: {
                TITLE: 'Presentation'
            },
            RESOURCE_ITEM: {
                TITLE: 'Resource'
            },
            RESOURCE_GROUPS: {
                TITLE: 'Resource Groups'
            },
            SUPPLIER_PAYMENT_TERM: {
                TITLE: 'Supplier Payment Terms'
            },
            INTEGRATION_MAPPING: {
                TITLE: 'Integration Mapping'
            },
            SUPPLIER_TRANSACTIONS: {
                TITLE: 'Supplier Ledger'
            },
            BIN_TYPES: {
                TITLE: 'Bin Types'
            },
            BINS: {
                TITLE: 'Bins'
            },
            SUPPLIER_GROUPS: {
                TITLE: 'Supplier Groups'
            },
            BUDGETS: {
                TITLE: 'Budgets'
            },
            PRODUCT_RE_SEQUENCE: {
                TITLE: 'Product Re-Sequence'
            },
            TELESALES_SCHEDULE: {
                TITLE: 'Telesales Schedule'
            },
            TELESALES_CALLS: {
                TITLE: 'Telesales Calls'
            },
            DRIVER_BREAKS: {
                TITLE: 'Driver Breaks'
            },
            CUSTOMER_PROSPECT_REPORT: {
                TITLE: 'Customer Prospect Report'
            }
        },
        MULTI_FRANCHISE: {
            TITLE: 'Multi Franchise Management',
            CUSTOMERS: {
                TITLE: 'Customers'
            }
        }
    }
};
